import resolveBadge, { BADGE } from './resolveBadge';

/**
 * Convenience predicate for surfaces that only care whether OUR branding shows
 * (confirmation CTA + pill, customer portal, email footer). Equivalent to
 * `resolveBadge(seller, theme) === 'checkoutpage'` — see `resolveBadge` for the
 * full three-state rules and the plan-based override.
 */
export default function shouldShowCheckoutPageBranding(seller, theme) {
  return resolveBadge(seller, theme) === BADGE.CHECKOUT_PAGE;
}
